function capitalize(str: string): string {
  return str && str.split(' ')
    .map((w) => (w.length ? w[0].toUpperCase() + w.substr(1).toLowerCase() : ''))
    .join(' ');
}

function enumerate(words: string[]): string {
  if (!words.length) return '';

  return words.reduce((acc, word, index) => (
    index === words.length - 1
      ? `${acc} and ${word}`
      : `${acc}, ${word}`
  ));
}

// Removes trailing zeros after $\d+ in a given string
// Ex: "$100.00" -> "$100"
function removeTrailingDecimals(input: string): string {
  return input.replace(/\$(\d+)\.00\b/g, '$$$1');
}

export { capitalize, enumerate, removeTrailingDecimals };
